import React from 'react';
import { CardBody, Col, Row } from 'reactstrap';
import logoEPartners2 from '../resources/basic_color.png'
// import { withRouter } from 'react-router-dom';
// import MenuImageView from '../../../resources/Roldn-Logistics.png';
// import ImagenROll from '../../../resources/Login_Logo2.png';
import './stylesPages.scss'


function Terminos_condociones(props) {

	return (
		<div>
			<Col xs={7} md={7} lg={7} className="ml-auto mr-auto">
				<CardBody>
					<div className='content'>
						<Row>
							<Col xs={3} className='mr-auto'>
							</Col>
							<Col xs={3} style={{ textAlign: "right" }} className='ml-auto'>
								<img src={logoEPartners2} alt="logo" />
							</Col>
						</Row>
						<hr />
						<h5 className="title-custom-value  text-center" >
							TÉRMINOS Y CONDICIONES – Onboard Logistics
						</h5>
					
					</div>
				</CardBody>
			</Col>
		</div>
	);
}
export default Terminos_condociones;